import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError } from '../../helper/Alert';
import {
  fetchAppointmentsSuccess,
  fetchAppointmentCalendarsSuccess,
} from '../actions';
import { IAppoinmentsModel } from '../../interfaces/Appointments';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { AxiosResponse } from 'axios';

const getAppointments = async (params: IAppoinmentsModel) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`Appointment/GetAppointments`, {
    params,
  });
};

const getAppointmentCalendars = async () => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`Appointment/GetAppointmentCalendars`);
};

function* fetchAppointmentCalendarsRequest(): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedAppointmentCalendars = yield call(getAppointmentCalendars);
    yield put(
      fetchAppointmentCalendarsSuccess(fetchedAppointmentCalendars.data),
    );
  } catch (error) {
    return ShowError('', error);
  }
}

export function* AppointmentCalendarsRequest() {
  yield takeEvery(
    ActionTypes.GET_APPOINTMENTS_CALENDARS,
    fetchAppointmentCalendarsRequest,
  );
}

function* fetchAppointmentsRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedAppointments = yield call(getAppointments, action.payload);
    yield put(fetchAppointmentsSuccess(fetchedAppointments.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* AppointmentRequest() {
  yield takeEvery(ActionTypes.GET_APPOINTMENTS, fetchAppointmentsRequest);
}

export default function* rootSaga() {
  yield all([fork(AppointmentRequest), fork(AppointmentCalendarsRequest)]);
}
